import axios from "axios"
import { createContext, useContext, useEffect, useMemo, useState } from "react"
import FeedBackBox from "../components/global/FeedBackBox"
import { URL } from "../config/apis"
import { getWindowSize } from "../helppers/glob"
import useAuth from "./Auth"

const DataContext = createContext()

export const DataContextProvider = ({ children }) => {
  const { user } = useAuth()

  const [loading, setLoading] = useState(false)
  const [show, setShow] = useState(false)
  const [err, setErr] = useState(null)
  const [size, setSize] = useState(getWindowSize())
  const [dealerships, setDealerships] = useState([])

  useEffect(() => {
    function handleWindowResize() {
      setSize(getWindowSize())
    }

    window.addEventListener("resize", handleWindowResize)

    return () => {
      window.removeEventListener("resize", handleWindowResize)
    }
  }, [])

  const getDealerships = async () => {
    try {
      const res = await axios.get(`${URL}/dealerships/all`, {
        headers: {
          "Content-Type": "application/json",
        },
        withCredentials: true,
      })
      setDealerships(res.data)
    } catch (error) {
      console.log(error.reaponse?.data?.message || error.message)
    }
  }

  useEffect(() => {
    if (user && user?.supperAdmin) {
      getDealerships()
    }
  }, [user])

  const disabled = useMemo(() => {
    if (!user?.dealerships?.map((d) => d?._id)?.includes(user?.selected?._id)) {
      return true
    } else {
      return false
    }
  }, [user])

  const memoedValue = useMemo(
    () => ({
      loading,
      setLoading,
      show,
      setShow,
      err,
      setErr,
      size,
      dealerships,
      disabled,
    }),
    [loading, show, err, size, dealerships, disabled]
  )

  return (
    <DataContext.Provider value={memoedValue}>
      <>{children}</>
      <>
        <FeedBackBox loading={loading} show={show} err={err} />
      </>
    </DataContext.Provider>
  )
}

export default function useData() {
  return useContext(DataContext)
}
